import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-start align-center" }
const _hoisted_2 = { class: "pt-2 pb-2" }
const _hoisted_3 = { class: "tableStyle" }
const _hoisted_4 = ["colspan"]
const _hoisted_5 = ["colspan"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "text-right"
}
const _hoisted_8 = {
  key: 1,
  class: "text-right"
}
const _hoisted_9 = ["colspan"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "text-right"
}
const _hoisted_12 = {
  key: 1,
  class: "text-right"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "text-right"
}
const _hoisted_15 = {
  key: 1,
  class: "text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.operatingAccountId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.operatingAccountId) = $event)),
                      items: _ctx.tableTypes,
                      "item-value": "id",
                      label: "Table",
                      "hide-details": "",
                      density: "compact",
                      "item-title": (item) => item.name
                    }, null, 8, ["modelValue", "items", "item-title"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.partitionTagId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.partitionTagId) = $event)),
                      items: _ctx.partitionTags,
                      "item-value": "id",
                      label: "Partition",
                      "hide-details": "",
                      density: "compact",
                      "item-title": (item) => item.name
                    }, null, 8, ["modelValue", "items", "item-title"])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPath, (tag, index) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "2",
                    key: index,
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: tag.selected,
                        "onUpdate:modelValue": ($event: any) => ((tag.selected) = $event),
                        items: tag.tags,
                        label: "Etiquette",
                        density: "compact",
                        "hide-details": "",
                        "return-object": "",
                        "item-title": (item) => item.name,
                        multiple: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables, (table, ti) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center",
                key: ti
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(table.name || "Comptes comptables"), 1),
                        _createVNode(_component_v_btn_icon, {
                          icon: "$oss-download",
                          onClick: _withModifiers(($event: any) => (_ctx.download(table)), ["stop"])
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_v_btn_icon, {
                          icon: "$oss-duplicate",
                          onClick: _withModifiers(($event: any) => (_ctx.copy(table)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        (!_ctx.operatingAccountId)
                          ? (_openBlock(), _createBlock(_component_oss_data_table, {
                              key: 0,
                              items: table.rows,
                              headers: [],
                              "fixed-header": true,
                              "hide-default-footer": "",
                              "items-per-page": -1,
                              "x-dense": true
                            }, {
                              header: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.headers, (tHeader, hi) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: hi }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tHeader, (column, ci) => {
                                      return (_openBlock(), _createElementBlock("th", {
                                        key: hi + '_' + ci,
                                        colspan: column.colspan || '',
                                        style: _normalizeStyle(_ctx.getHeaderStyle(hi, column, ci)),
                                        class: _normalizeClass(_ctx.getHeaderClass(hi, column, ci))
                                      }, _toDisplayString(column.text), 15, _hoisted_4))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]),
                              item: _withCtx(({ item }) => [
                                (item.title && !item.total)
                                  ? (_openBlock(), _createElementBlock("tr", {
                                      key: 0,
                                      class: "text-left",
                                      style: _normalizeStyle(_ctx.itemRowBackground(item))
                                    }, [
                                      _createElementVNode("td", {
                                        colspan: "1",
                                        class: "vertical-sticky",
                                        style: _normalizeStyle(_ctx.verticalSepratorStyle)
                                      }, [
                                        _createElementVNode("strong", null, _toDisplayString(item.title), 1)
                                      ], 4),
                                      _createElementVNode("td", {
                                        colspan: _ctx.getColumnCount(table) - 1
                                      }, null, 8, _hoisted_5)
                                    ], 4))
                                  : (_openBlock(), _createElementBlock("tr", {
                                      key: 1,
                                      style: _normalizeStyle(_ctx.itemRowBackground(item)),
                                      onClick: _withModifiers(($event: any) => (_ctx.openAABDetailDialog(item.aaName)), ["stop"])
                                    }, [
                                      _createElementVNode("td", {
                                        class: "text-left vertical-sticky",
                                        style: _normalizeStyle(_ctx.colorElement2(item))
                                      }, _toDisplayString(_ctx.getRowTitle(item)), 5),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPeriods, (period, pi) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columns, (col, ci) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              class: "text-right",
                                              style: _normalizeStyle(
                                                _ctx.addVerticalSeparatorStyle(table, ci, pi)
                                                    ? _ctx.verticalSepratorStyle
                                                    : ''
                                            ),
                                              key: `${ti}-${pi}-${ci}`
                                            }, _toDisplayString(_ctx.getAmountFormatted(table, item, col, pi)), 5))
                                          }), 128)),
                                          (table.relativePercentage)
                                            ? (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                key: `${ti}-${pi}-relativePercentage`
                                              }, _toDisplayString(_ctx.getRelativePercentage(item, pi)), 1))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 256)),
                                      (table.comparison?.difference)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.formatDifference(item)), 1))
                                        : _createCommentVNode("", true),
                                      (table.comparison?.percentage)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.formatPercentage(item.percentage)), 1))
                                        : _createCommentVNode("", true)
                                    ], 12, _hoisted_6))
                              ]),
                              _: 2
                            }, 1032, ["items"]))
                          : (_openBlock(), _createBlock(_component_oss_data_table, {
                              key: 1,
                              items: table.rows,
                              headers: _ctx.getHeaders(table),
                              "hide-default-footer": "",
                              "items-per-page": -1,
                              class: "table",
                              "x-dense": true,
                              "fixed-header": "",
                              "item-key": "key"
                            }, {
                              item: _withCtx(({ item }) => [
                                (item.title && !item.total)
                                  ? (_openBlock(), _createElementBlock("tr", {
                                      key: 0,
                                      class: "text-left",
                                      style: _normalizeStyle(_ctx.itemRowBackground(item))
                                    }, [
                                      _createElementVNode("td", {
                                        colspan: "1",
                                        class: "vertical-sticky",
                                        style: _normalizeStyle(_ctx.verticalSepratorStyle)
                                      }, [
                                        _createElementVNode("strong", null, _toDisplayString(item.title), 1)
                                      ], 4),
                                      _createElementVNode("td", {
                                        colspan: _ctx.getColumnCount(table) - 1
                                      }, null, 8, _hoisted_9)
                                    ], 4))
                                  : (_ctx.withAmountOrNotOptional(item))
                                    ? (_openBlock(), _createElementBlock("tr", {
                                        key: 1,
                                        style: _normalizeStyle(_ctx.itemRowBackground(item)),
                                        onClick: _withModifiers(($event: any) => (item.isExpanded = !item.isExpanded), ["stop"])
                                      }, [
                                        _createElementVNode("td", {
                                          class: "text-left vertical-sticky",
                                          style: _normalizeStyle(_ctx.colorElement2(item))
                                        }, _toDisplayString(_ctx.getRowTitle(item)), 5),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPeriods, (period, pi) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columns, (col, ci) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                style: _normalizeStyle(
                                                _ctx.addVerticalSeparatorStyle(table, ci, pi)
                                                    ? _ctx.verticalSepratorStyle
                                                    : ''
                                            ),
                                                key: `${ti}-${pi}-${ci}`
                                              }, _toDisplayString(_ctx.getAmountFormatted(table, item, col, pi)), 5))
                                            }), 128)),
                                            (table.relativePercentage)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: `${ti}-${pi}-relativePercentage`
                                                }, _toDisplayString(_ctx.getRelativePercentage(item, pi)), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256)),
                                        (table.comparison?.difference)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_ctx.formatDifference(item)), 1))
                                          : _createCommentVNode("", true),
                                        (table.comparison?.percentage)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.formatPercentage(item.percentage)), 1))
                                          : _createCommentVNode("", true)
                                      ], 12, _hoisted_10))
                                    : _createCommentVNode("", true),
                                (item.isExpanded)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(item.subRows, (subrow, subR) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: `${item.id}-${subR}`,
                                        class: "elevation-1",
                                        style: {"border":"0"}
                                      }, [
                                        _createElementVNode("td", {
                                          class: "text-left font-italic vertical-sticky",
                                          style: {"box-shadow":"inset -1px 0px grey"},
                                          onClick: _withModifiers(($event: any) => (_ctx.openAABDetailDialog(subrow.name)), ["stop"])
                                        }, "      " + _toDisplayString(subrow.name + " - " + subrow.description), 9, _hoisted_13),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultPeriods, (period, pi) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.columnsToDisplay[pi], (col, ci) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                key: `${item.id}-${pi}-${ci}-${subR}`,
                                                class: "text-right font-italic",
                                                style: _normalizeStyle(
                                                    _ctx.getCellStyle(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                )
                                              }, _toDisplayString(_ctx.getAmountFormatted(
                                                        table,
                                                        item,
                                                        col,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )), 5))
                                            }), 128)),
                                            (table.relativePercentage)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  class: "text-right",
                                                  key: `${item.id}-${pi}-relativePercentage-${subR}`
                                                }, _toDisplayString(_ctx.getRelativePercentage(subrow, pi)), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 256)),
                                        (table.comparison?.difference)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_14))
                                          : _createCommentVNode("", true),
                                        (table.comparison?.percentage)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_15))
                                          : _createCommentVNode("", true),
                                        (table.extraColumns)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(table.extraColumns, (column) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: "text-right",
                                                key: column.name
                                              }))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _cache[3] || (_cache[3] = _createElementVNode("template", null, null, -1))
                              ]),
                              _: 2
                            }, 1032, ["items", "headers"]))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_ctx.AABDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 0,
                  modelValue: _ctx.AABDialog,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.AABDialog) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_AccountableAccountBalanceDetail, {
                              companyId: _ctx.companyId,
                              accountingPeriodId: _ctx.accountingPeriodId,
                              accountableAccountInfo: { name: _ctx.selectedAccountableAccountName },
                              startDate: _ctx.date.start,
                              endDate: _ctx.date.end,
                              onRefresh: _ctx.refresh
                            }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "startDate", "endDate", "onRefresh"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}